import { all } from 'redux-saga/effects';
import { watchList } from './list';

export function* watchDiseaseCodes() {
  yield all([watchList()]);
}
